import { useQuery } from '@tanstack/react-query';
import { VehicleDocumentApi } from 'api';

export function useGetVehicleDocuments(vehicleId) {
  return useQuery({
    queryKey: ['vehicle-documents', vehicleId],
    queryFn: () => VehicleDocumentApi.getAllByVehicleId(vehicleId),
  });
}
